export default "__VITE_ASSET__Dq7ie3gc__"